import { Controller } from "@hotwired/stimulus"
import { track } from "../lib/umami"
import { deferUntilIdle } from "../lib/defer_until_idle"
import { stripSrcBeforeTurboCache } from "../lib/lazy_frame"

// Pose le `src` de l'iframe de démo du hero après `load` + inactivité (ou à la
// première interaction). `loading="lazy"` ne suffit pas ici : sur mobile le
// téléphone est à moins d'un écran sous les CTA, donc dans la marge de
// pré-chargement du navigateur, et le second document (97 Ko + bundle JS)
// concurrençait le LCP dans 90 % des atterrissages. Une iframe hors écran
// n'étant pas non plus fiable via IntersectionObserver (même marge), on diffère
// sur le cycle de vie de la page. Le <noscript> voisin garde la démo visible
// pour Googlebot sans JS et les clients sans JS.
export default class extends Controller {
  static values = { src: String, loadedEvent: String }

  connect() {
    // Le src est retiré avant la mise en cache Turbo : un snapshot ne recharge pas la démo.
    this.stopStripping = stripSrcBeforeTurboCache(this.element)
    if (this.element.getAttribute("src")) return
    this.cancel = deferUntilIdle(window, () => this.#load())
  }

  disconnect() {
    this.cancel?.()
    this.stopStripping?.()
  }

  #load() {
    if (this.loadedEventValue) {
      this.element.addEventListener("load", () => {
        track(this.loadedEventValue, {
          viewport: window.matchMedia("(min-width: 1024px)").matches ? "desktop" : "mobile"
        })
      }, { once: true })
    }
    this.element.src = this.srcValue
  }
}
